import { InputNumber } from "antd";
import { CSSProperties } from "react";
import { formatMoney } from "shared/plugins/string-helper";

export interface IMoneyInputProps {
  onChange?: (value: number) => void;
  value?: number;
  bordered?: boolean;
  className?: string;
  textAlign?: "right";
  hideUpDownBtn?: boolean;
  placeholder?: string;
  style?: CSSProperties;
  disabled?: boolean;
}

export function MoneyInput(props: IMoneyInputProps) {
  const {
    value,
    onChange,
    bordered,
    className,
    textAlign,
    hideUpDownBtn,
    placeholder,
    style,
    disabled,
  } = props;
  return (
    <InputNumber
      placeholder={placeholder}
      bordered={bordered}
      className={[
        className,
        "customMoneyInput",
        textAlign ? `customMoneyInput--${textAlign}` : "",
        hideUpDownBtn ? "customMoneyInput--hideUpDown" : "",
      ].join(" ")}
      value={value}
      formatter={(value) => formatMoney(value, 0, ".", ",", "")}
      parser={(value) => Number(value?.replace(/\₫\s?|(,*)/g, ""))}
      onChange={(e) => {
        onChange && onChange(e);
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          onChange && onChange(0);
        }
      }}
      style={style}
      disabled={disabled}
    />
  );
}
